// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 378 ? "user" : chunkId) + "." + {"13":"5af96d51","378":"ac4e9715","529":"cebd61f0"}[chunkId] + ".chunk.js";
};